// 회전 코드 표시 스타일 단일 소스 — 목록 칩(TotpCodeChip)과 상세 뷰(TotpFieldView) 공용.
// 두 곳에 인라인으로 각각 두었더니 letterSpacing 이 0.08em / 0.1em 으로 어긋나, 같은 코드가
// 화면마다 다른 굵기·밀도로 보였다(사용자 지적). 여기서만 정의해 재발을 막는다.
// tabular-nums: 자릿수가 바뀌어도 폭이 흔들리지 않게 고정폭 숫자 사용
// nowrap: 26px 로 커진 코드가 좁은 폭에서 그룹 구분 공백을 기준으로 줄바꿈되는 것 방지
export const TOTP_CODE_FONT_SIZE = 26

// 테이블 모드 × 좁은 화면 전용 축소값. 코드가 고정 폭을 차지하면 자동 배분 컬럼인
// 이름/URL 이 밀려 "te…" 수준으로 잘려 어느 계정인지 식별할 수 없다(모바일 실측).
export const TOTP_CODE_FONT_SIZE_COMPACT = 20

export function getTotpCodeStyle(fontSize = TOTP_CODE_FONT_SIZE) {
  return {
    fontVariantNumeric: 'tabular-nums',
    letterSpacing: '0.08em',
    fontWeight: 700,
    fontSize,
    whiteSpace: 'nowrap',
  }
}
